import Swal from 'sweetalert2';

export default class LogoutDialog {
  show() {
    if(!gon.is_confirm_logout) return;
    Swal.fire({
      title: gon.views.companytools.logout_dialog.question,
      text: gon.views.companytools.logout_dialog.description,
      showCancelButton: true,
      confirmButtonText: gon.views.companytools.logout_dialog.ok,
      cancelButtonText: gon.views.companytools.logout_dialog.cancel,
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        window.location = Routes.sign_out_company_user_logins_path(gon.locale, { return_to_url: window.location.href })
      } else {
        window.location = Routes.dashboard_index_path(gon.locale)
      }
    })
  }
}
